// src/components/DeleteConfirmModal.js
import React, { useState } from 'react';

export default function DeleteConfirmModal({ open, agent, onClose, onConfirm }) {
  const [deleting, setDeleting] = useState(false);

  if (!open || !agent) return null;

  const handleConfirm = async () => {
    setDeleting(true);
    await onConfirm(agent);
    setDeleting(false);
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4" onClick={onClose}>
      <div className="absolute inset-0" style={{ background: 'rgba(0,0,0,0.7)', backdropFilter: 'blur(8px)' }} />
      <div
        className="relative w-full max-w-sm card-glass rounded-2xl p-6 animate-slide-up text-center"
        onClick={e => e.stopPropagation()}
      >
        <div className="w-12 h-12 rounded-2xl bg-red-500/10 flex items-center justify-center mx-auto mb-4">
          <svg viewBox="0 0 24 24" className="w-6 h-6 text-red-400" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/>
            <path d="M10 11v6M14 11v6M9 6V4h6v2"/>
          </svg>
        </div>
        <h3 className="font-display font-700 text-white mb-2">Delete Agent?</h3>
        <p className="text-slate-400 text-sm mb-6">
          Are you sure you want to delete <span className="text-white font-600">{agent.name}</span>? This action cannot be undone.
        </p>
        <div className="flex gap-3">
          <button
            onClick={onClose}
            className="flex-1 py-2.5 rounded-xl font-display font-600 text-sm text-slate-400"
            style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.08)' }}
          >
            Cancel
          </button>
          <button
            onClick={handleConfirm}
            disabled={deleting}
            className="flex-1 py-2.5 rounded-xl font-display font-600 text-sm text-white bg-red-500/80 hover:bg-red-500 transition-colors disabled:opacity-50"
          >
            {deleting ? 'Deleting...' : 'Delete'}
          </button>
        </div>
      </div>
    </div>
  );
}
